import { emptyObj } from 'util/objects'

export const selectBase = state => state.billing || emptyObj

export default selectBase
